import { FC } from 'react'

import Typography from '@/ui/components/typography'
import { IconSlot, Wrapper } from './SectionHeader.styles'
import { SectionHeaderProps } from './SectionHeader.types'

const SectionHeader: FC<SectionHeaderProps> = ({
    icon,
    title,
    count,
    dataTestId,
}) => {
    const hasCount = !!count && count > 0

    return (
        <Wrapper data-testid={dataTestId}>
            <IconSlot>{icon}</IconSlot>
            <Typography variant="l-regular" component="h2">
                {title}
            </Typography>
            {hasCount && (
                <Typography
                    variant="l-regular"
                    component="span"
                    testId={`${dataTestId ?? 'section'}-count`}
                >
                    ({count})
                </Typography>
            )}
        </Wrapper>
    )
}

export default SectionHeader
